import { PRESETS } from '../utils/presets';

export const RESEND_INDICATION_TTL_TIMER = 30000;
export const RESEND_INDICATION_TTL_TIMER_FOR_WIX_APP_ENFORCEMENT = 10000;

export const EXPERIMENTS = {
  CREATE_PASSWORD_OFFER: 'specs.ident.createPasswordOffer',
  TWO_FA_AGGRESSIVE_OFFER: 'specs.ident.2faAggresiveOffer',
  SHOULD_SHOW_POST_LOGIN_OWNER_APP2_FA:
    'specs.ident.ShouldShowPostLoginOwnerApp2Fa',
  SHOW_ERROR_MESSAGE_FOR_FACEBOOK2_FA_USERS:
    'specs.ident.showErrorMessageForFacebook2FaUsers',
  SHOULD_SHOW_WIX_APP_ENFORCEMENT: 'specs.ident.shouldShowWixAppEnforcement',
  SHOULD_STEPUP_EDIT_2FA: 'specs.ident.shouldStepupEdit2FA',
  SHOULD_ACTIVATE_NEW_COLORS_BRANDING:
    'specs.ident.ShouldActivateNewColorBrandingForAccountSettings',
  SHOULD_USE_NEW_POST_LOGIN_URLS: 'specs.ident.shouldUseNewPostLoginUrls',
  SHOULD_ENABLE_WIXEL: 'specs.ident.shouldEnableWixel',
  IGNORE_REFERRAL_INFO_FOR_POST_LOGIN:
    'specs.ident.IgnoreReferralInfoForPostLogin',
  PRIORITIZE_USER_TYPE_OVER_QUERY_PARAMS:
    'specs.ident.prioritizeUserTypeOverQueryParam',
  ENABLE_PASSKEY_LOGIN: 'specs.ident.enablePasskeyLogin',
  SHOULD_ACTIVATE_WIX_2025_PRESET: 'specs.users.ShouldActivateWix2025Preset',
  SHOULD_ACTIVATE_WIX_2025_FOR_BRANDS:
    'specs.ident.shouldActivateWix2025ForBrands',
  SHOULD_SHOW_POST_LOGIN_PASSKEY_OFFER:
    'specs.ident.ShouldShowPostLoginPasskeyOffer',
};

export const BI_SCREEN_NAMES = {
  CHOOSE_DEVICE: 'choose_device',
  CONFIRM_DEVICE: 'confirm_device',
  CANCEL_SETUP: 'cancel_setup',
  FAILED_TO_CONFIRM_DEVICE: 'failed_to_confirm_device',
  LOGIN_REQUEST_DENIED: 'login_request_denied',
  CHOOSE_VERIFICATION_METHOD: 'choose_verification_method',
  APPROVE_DEVICE: 'approve device',
  ENFORCEMENT_FAILED_TO_CONFIRM_DEVICE: 'failed_to_confirm_device',
  ENFORCEMENT_LOGIN_REQUEST_WAS_DENIED: 'Login request was denied',
};

export const BI_BUTTON_NAMES = {
  NEXT: 'Next',
  MAYBE_LATER: 'Maybe Later',
  ACCOUNT_SETTINGS: 'Account Settings',
  BACK: 'Back',
  CANCEL: 'Cancel',
  RESEND_LOGIN_REQUEST: 'Resend Login Request',
  CANCEL_SETUP: 'Cancel Setup',
  X_BUTTON: 'X_button',
  SET_UP: 'Set Up',
  LEARN_MORE: 'Learn more',
  CONFIRM_EMAIL: 'confirm',
  RESEND_EMAIL: 'resend',
};

export const BI_ORIGIN = {
  TWO_FA_ENFORCEMENT: '2fa_enforcement',
  TWO_FA_ENFORCEMENT_SECOND_METHOD: '2fa_enforcement_second_method',
  POST_SIGNUP: 'Post Signup',
};

export const BI_ERROR_TYPE = {
  EXPIRED_CODE: 'code expired',
  INCORRECT_CODE: 'code incorrect',
};

export const CUSTOMER_CARE_BLOCKED_ACCOUNT_BOT_URL =
  'https://www.wix.com/support-chatbot?nodeId=aecd4efb-caf3-404d-b5f7-6f9a808f8853';

export const FUNNELS_WITHOUT_SSO = [
  PRESETS.WIXEL,
  PRESETS.EDUCATION_STUDENT,
  PRESETS.EDUCATION_TEACHER,
];
